// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .btn:hover{
    background-color: #83a3ce !important;
}
 */
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/TrendAnalysis_Bus/Trend.css"],"names":[],"mappings":"AAAA;;;EAGE","sourcesContent":["/* .btn:hover{\n    background-color: #83a3ce !important;\n}\n */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
